const STORAGE_KEY = "alidrop_categories_cache";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

interface CachedCategories {
  data: Array<{
    id: number | string;
    external_id: string;
    name: string;
    is_visible: boolean;
    is_active: boolean;
    image: string;
    parent: number | null;
  }>;
  timestamp: number;
}

export function getCachedCategories(): CachedCategories["data"] | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return undefined;
    const parsed: CachedCategories = JSON.parse(raw);
    if (!parsed.data || !Array.isArray(parsed.data)) return undefined;
    if (Date.now() - parsed.timestamp > MAX_AGE_MS) return undefined;
    return parsed.data;
  } catch {
    return undefined;
  }
}

export function setCachedCategories(
  data: CachedCategories["data"]
): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ data, timestamp: Date.now() })
    );
  } catch {
  }
}
